import React, { Component } from "react";
import {
  SliderBox,
  Icon,
  CloseIcon,
  SliderWrap,
  SliderLink,
  SliderMenu,
  SBWrap,
  SliderRoute,
} from "./atoms";

class Slider extends Component {
  render() {
    return (
      <>
        <SliderBox isOpen={this.props.isOpen} onClick={this.props.toggleSlider}>
          <Icon>
            <CloseIcon />
          </Icon>
          <SliderWrap>
            <SliderMenu>
              <SliderLink to="about" onClick={this.props.toggleSlider}>
                About
              </SliderLink>
              {/* <SliderLink to="discover" onClick={this.props.toggleSlider}>
                Discover
              </SliderLink> */}
              <SliderLink to="services" onClick={this.props.toggleSlider}>
                Services
              </SliderLink>
              <SliderLink to="projects" onClick={this.props.toggleSlider}>
                Projects
              </SliderLink>
            </SliderMenu>
            <SBWrap>
              <SliderRoute href={process.env.PUBLIC_URL + "/cv.pdf"}>
                Download CV
              </SliderRoute>
            </SBWrap>
          </SliderWrap>
        </SliderBox>
      </>
    );
  }
}

export default Slider;
